/*
    Purple MobileApp scheme
*/
export const PURPLE_SCHEME = {
    close: 'nc2://close',
    //external: 'nc2://external?url=', // 웹뷰일 때
    external: 'ncmtalk://webview?type=wk&url=', // 인앱브라우저일 때
    webview: 'ncmtalk://webview?type=wk&url='
};